import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import './design-guidelines-styles.css';
export const _frontmatter = {
  "pageTitle": "Tables Design Guidelines",
  "title": "Table",
  "order": 1
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageContent = makeShortcode("PageContent");
const LeadParagraph = makeShortcode("LeadParagraph");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <PageContent componentName="table" type="design" mdxType="PageContent">
      <LeadParagraph mdxType="LeadParagraph">
  Tables are used to organize and display data efficiently. The table component
  allows for customization with additional functionality, as needed by your
  product’s users.
      </LeadParagraph>
      <p><span parentName="p" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.521235521235525%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA6ElEQVQY042Qy04DMQxF5/+/EDaoSEEV05TJ0684NnQC6pazs62je+XNzOQPZh5j+L/ZVPV6vd5utxjjvu8xRiICABEZJyIM+BzXlZnNbJtz3u/3lBKfiMhxHCGEWisRMdPXVwrhA7EDACLGGEMIpZQ55+buiFhrHWPYiYi01ohoDHWbpcrn3lvD3mGMwcylFFV91Hb33nspBQDMzN3XeaE6WpeX1+PtkgEeMiKmlETkKddaVXUlLznnjEjuXhtf3nPKnQhEHnLO+TfZzACgtbZ+sGr33tfG3ZCGnL8gIlVl5tbanPNH/gYmAJZIdFoxNwAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": " ",
            "title": " ",
            "src": "/static/b620f9c99f776664758ff3f5ae49f8e2/e3189/tables-intro-image.png",
            "srcSet": ["/static/b620f9c99f776664758ff3f5ae49f8e2/a2ead/tables-intro-image.png 259w", "/static/b620f9c99f776664758ff3f5ae49f8e2/6b9fd/tables-intro-image.png 518w", "/static/b620f9c99f776664758ff3f5ae49f8e2/e3189/tables-intro-image.png 1035w", "/static/b620f9c99f776664758ff3f5ae49f8e2/44d59/tables-intro-image.png 1553w", "/static/b620f9c99f776664758ff3f5ae49f8e2/c9d77/tables-intro-image.png 1964w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span></p>
      <h2>{`Usage`}</h2>
      <p>{`Tables display information in a grid-like format of rows and columns. They organize information in a way that’s easy to scan so that users can look for patterns and develop insights from data.`}</p>
      <p><strong parentName="p">{`Tables can contain:`}</strong></p>
      <ul>
        <li parentName="ul">{`Interactive components (such as inputs, buttons, or menus)`}</li>
        <li parentName="ul">{`Non-interactive elements (such as badges)`}</li>
        <li parentName="ul">{`Tools to query and manipulate data`}</li>
      </ul>
      <h3>{`When to use`}</h3>
      <ul>
        <li parentName="ul">{`To organize and display data.`}</li>
        <li parentName="ul">{`If your user must navigate to a specific piece of data to complete a task.`}</li>
      </ul>
      <h3>{`When not to use`}</h3>
      <ul>
        <li parentName="ul">{`When a more complex display of the data or interactions are required.`}</li>
        <li parentName="ul">{`As a replacement for a spreadsheet application.`}</li>
      </ul>
      <hr></hr>
      <h2>{`Anatomy`}</h2>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "44.4015444015444%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAJCAIAAAC9o5sfAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA2UlEQVQoz5WR204DMQxE8///CC97gW2XBja2x7XdFG2C0KoCIc7TKNJoZuJUzevVo3H/J8mfX69PL+f3y2lZzOx2wN2vjd90iiXH6WPNl2kc13VlZiIqpRBRznkcx2majpqZc87DMMzznPZ4vwGgRill2zYiYmYz648i4u5dA4gIIlLVVNUqAYqeJiKq2ieZWWkAcPcHDSDF/BbDGW7d3Ge77194THvQX+YWEQAKlT64dxaR79oAjvpgrvtmVe0GEQHQa7u7iDCzqkYEN1S1t9g3/3jA2vjzzp8bywqyqJQyaAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/20603f13e34acf89c07b37d21c35917e/e3189/table-anatomy.png",
            "srcSet": ["/static/20603f13e34acf89c07b37d21c35917e/a2ead/table-anatomy.png 259w", "/static/20603f13e34acf89c07b37d21c35917e/6b9fd/table-anatomy.png 518w", "/static/20603f13e34acf89c07b37d21c35917e/e3189/table-anatomy.png 1035w", "/static/20603f13e34acf89c07b37d21c35917e/44d59/table-anatomy.png 1553w", "/static/20603f13e34acf89c07b37d21c35917e/c9d77/table-anatomy.png 1964w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <ol>
        <li parentName="ol">{`Table title`}</li>
        <li parentName="ol">{`Table header`}</li>
        <li parentName="ol">{`Table rows`}</li>
      </ol>
      <hr></hr>
      <h2>{`Sizing`}</h2>
      <p>{`Tables come in three different sizes or densities: compact, normal, and loose. This is applied to the entire table and not just a specific row or cell.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "120.07722007722008%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAYCAIAAAB1KUohAAAACXBIWXMAAAsTAAALEwEAmpwYAAACOUlEQVQ4y5VU25abMAzM/3/j7hKyJwEbG+OLbIxt6IEhbpr2YTsPOUHJSGhG0mXbtnmevfchBO/9uq7bj3HZtm0cR8YYP5BSWl9QSsk5p5Ryzm+PJ3kYhrZtb7eb1pqIjDHWWq21O/D19dU0Tdu2zjki+vj4uF6vbdtaa3ey1poxNgwD51xK2fe91lpKaa2d51lKKYQYhkEpFWMcDogDJ5lzLoTgnGutjTExxpTSsizeeykl8iql5nlGot/kcRzv93t3YBxHKaX3fj5ARIyxrusej8cwDCGEvu8fj0d/4AJ56ycK5pzLgSoP8BbZK0MYY0wIYfsf7GSlFBqbpin/BVT7J86em6b5/v4WQhCRtRaueO+VUrDqdrsR0TRNn5+f+LNzbifHGI0x7gkics7B55SSfcJ7n1JyzllrjTFEdPYsD0BqKWXNRUTqCYzQNE31cScTkRACzPqnahXSCSGUUkRUCyildnJKCR1675dledWzlII4EcUYSynYHwzC5U39uhI/tWqaJiEEYww+/3wrd7L3HgI65+Y/gZckohDCawQ41cbS3e/3ahi86fu+aZrr9co5RxYhBHzuuu4UbDmAxCiSDsQYEYFCOecYI76flUsp4zhiH0MI8AldLctSySklVMLNCiHs5Jxz/Rm3ps5zKaXeIwRrZF3Xs2esOO4JY0wIgQnHG3HOGWNKKeecUqqenQuuZx1gSPU6YYgbY7z3aBhH7rxh67qiVVj16uSyLBg+5xyGD+OINn8BmtNliumBFioAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/0bd621bdcdd9af0fee05ad2a340538ef/e3189/table-densities.png",
            "srcSet": ["/static/0bd621bdcdd9af0fee05ad2a340538ef/a2ead/table-densities.png 259w", "/static/0bd621bdcdd9af0fee05ad2a340538ef/6b9fd/table-densities.png 518w", "/static/0bd621bdcdd9af0fee05ad2a340538ef/e3189/table-densities.png 1035w", "/static/0bd621bdcdd9af0fee05ad2a340538ef/71c1d/table-densities.png 1536w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <h3>{`Compact Density`}</h3>
      <p>{`The compact density can be useful for tables with a relatively large number of columns and rows by allowing you to simply fit more on the screen at once.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "37.83783783783784%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABgklEQVQY023Mu27UQBTGcb8XJS09DVLegYoOiVCAFCo6HiBQUNHQUCAQVaRdaVGUteO7PfY5Zy4e3zJje+1BgQIJ8ev++qTPc/9Yt9U5enEJTy7qx6/E20+bc9tp3bbtft3+cs55UiqplFINIC7L4ja3OgcvL8uzi+LsjXj3+c+j+x8vD26SJEnjWAkxWTNbM8/TNN4ZM9vVEEQVq6qyUEou1ujkuijympWEMFnjyeOekpAiX2axLhIV3ao0pMNB+rdTei13XyEOMTxSHIx13u2/1JEP9+nrMvVkegRW8CqvspgTg1F0yzA629/1FmMVXEHFiOV1nra86o8/sCqozJBlVOWeYilyyZFQSelneP5evP4ozj+MCZ0abMIDCkWcAGnouzHaIRdIRMSFlJ4sYiCOdQ1asu/7+OGz9NHz8MFT+e3nxFIZ7IALBKhr6LTqgyskAgBE5Jx7PZa669u2bZrGTNaeFrPMdp1n504tDcWN7oa21Y3WZhxMstdtq3/ruu4XZtewptf/vMkAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/f6cfb7cf025c28fac81439b6f5be6cb5/e3189/compact-density.png",
            "srcSet": ["/static/f6cfb7cf025c28fac81439b6f5be6cb5/a2ead/compact-density.png 259w", "/static/f6cfb7cf025c28fac81439b6f5be6cb5/6b9fd/compact-density.png 518w", "/static/f6cfb7cf025c28fac81439b6f5be6cb5/e3189/compact-density.png 1035w", "/static/f6cfb7cf025c28fac81439b6f5be6cb5/71c1d/compact-density.png 1536w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <h3>{`Normal Density`}</h3>
      <p>{`The default padding of tables is optimized for a nice balance between compact and loose densities.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "41.31274131274131%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAABlElEQVQY022LsW7TUBRA/UmID2BgQHwMEisSgp/owIhYYEJqikAIJloooNImIYnjNPaz6yR17Pv84nfffbbr2r4ogpGjs5zhOMxcVhURGcSSLDNX0Xbz8Hly/+n1g2dVnDEz9z3/D4eZUYFSSub5bld0zFWuk4PD5GCQvDiqNuueuev7vV3XWd117b/se4e5M+IiEsE6jiRsS8KysmWhy6apubXDgfCmV1F4FQqrFZ0PQm8aRSKOBKF2uG2b+TH5QyvGfy2jiZ2dGe+cFr9uT17S5RkFYwrG1r+4/fqKLn+SGFMwomDkcN/Zxel2+Tv1p6k/S4NZJlwZe2q1LOJF/f21XI4gnEPo5WJa/Xgj/RGEHoQuCNfhvq03boFGF2jaJvky9O88iu8+Xt17gvOwHn/QShZIGknrXTX5qBVoYzVigWY/N9dzRG0QTWn1KpGH3+DtMRydNoY695NREg0ZYywWrfvZKEAiY9AY3M82nqRpCgCQZaDy/MbmNxZqAkjL4TtI1hlIACmzbTl6L5N1JiVke/4A7Duug2DcUdsAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/1ae41e0deadc7f7b9707c564a5e895f2/e3189/normal-density.png",
            "srcSet": ["/static/1ae41e0deadc7f7b9707c564a5e895f2/a2ead/normal-density.png 259w", "/static/1ae41e0deadc7f7b9707c564a5e895f2/6b9fd/normal-density.png 518w", "/static/1ae41e0deadc7f7b9707c564a5e895f2/e3189/normal-density.png 1035w", "/static/1ae41e0deadc7f7b9707c564a5e895f2/71c1d/normal-density.png 1536w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <h3>{`Loose Density`}</h3>
      <p>{`The loose density can be useful if you have a relatively small amount of data and if the user would benefit from the table having more white-space within it.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "49.034749034749034%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB80lEQVQoz3XRzW8SQQAF8P0PTbx5auLZePDgvRrTxJieNMGYJo2WerCX2qS0pJpSPhYQsZVCBRaWZVjYT3ZnhtmZ2Z3ZNXCyB9/xl/dOT8nuRwrhvDh0nuSsrd3wqLwhmf0nCgyh57mu62KMsywTiZg9ez/bejN9+NI7+L6uiH/G6f1x1K94puEF4XIZUMoo5yRiJEmYWaWgCSGGCCOEaZywcZP9LqDAh5hAiCJKlfjmBHRbAExnkxEOfbIKV2BOrAW72kO1vKFrQB+ZxjgimF5/jUq56bALDB3oIxR4iqwfiN6FMNrJuEEHNaap9LYc/6nK4mtResdHjVir82GNanVZ+SDOduJ+mWsNrqlsqCrZbcEd/JrpIx9MiDOPnDlxrZTCrJmXN8dk6RDfJr7NUJjdFVN1P3LBaoMM+opQP8adc641hNmW6E6EXRn0Er2eFHbE5Vs5aUn9h9SbcvIzKeXE6SupVTbYFHpT4Z2Cow8WGIOTyvxpbv58b76dhzOLqvlV+9iyHcu2Lcty/CDqFqPqvm1OFxt0PU9JuufUMVmWOV8uwYPt6aMd4/Eu1gBXD3nnlDHG1h9ElCe8d8HVTwwHlPE1Mqqk/W/YBhCtIMFLikWarr9MZXZ9JHpnECIIIQzDVUSz0VXa+oyXLoQIQUgI+Qvj9BR514/ObAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/f3ba439c67badf47a8304b923f3eeace/e3189/loose-density.png",
            "srcSet": ["/static/f3ba439c67badf47a8304b923f3eeace/a2ead/loose-density.png 259w", "/static/f3ba439c67badf47a8304b923f3eeace/6b9fd/loose-density.png 518w", "/static/f3ba439c67badf47a8304b923f3eeace/e3189/loose-density.png 1035w", "/static/f3ba439c67badf47a8304b923f3eeace/71c1d/loose-density.png 1536w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <hr></hr>
      <h2>{`Content`}</h2>
      <h3>{`Table Title and Description`}</h3>
      <ul>
        <li parentName="ul">{`The table title should make it clear to the user what the data is and what purpose it serves in the UI.`}</li>
        <li parentName="ul">{`A description can be added under the title to provide more information about the data or its source.`}</li>
      </ul>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "76.83397683397683%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsTAAALEwEAmpwYAAABXUlEQVQoz42S627CMAyFef/Xmhg/hiamTUJjE7BeQtK0NG1jJ01zmWgZu7WIT1EUxT45juVZCMGjdkK6Cs5LSCdVuIGZb023Z/4ow1H6vPZ5HQR0O+ZRn+L+uhi0pWVcsIfV4/6Qvn3sVps1JlmA9gaxarstxQM/vseYckx4FR30JvFwg3MIwTWoeQm0qEkmaa54CaxAAJyg/uIk9t63tnt6eb67n683rzRjhSgRUTZylOVyuVgs5vP5WYyICtVpVwoAQMIVtNZD5uzygaZp6rouy1IIYYzx04ieqqrOziGEQcY5z7JMKTXcj1L2CCHOzs654Yk/uDGGkPf+27koiu12G0VRnudxHBNCOOeX1J8wxtI0JYR8O1trEbFt267rjDFtj7X2v7PtMcbMLjUMfUZErbVSavjIaNkA0DQNIv4qmxDCGKuqilJqrZ0aLMYYpTRJkpGGDQc3zWU8PwGviWZLbvWvEgAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/0ce30b06d3e994e3a1b0f8b3ac537198/8ae3e/table-title.png",
                  "srcSet": ["/static/0ce30b06d3e994e3a1b0f8b3ac537198/a2ead/table-title.png 259w", "/static/0ce30b06d3e994e3a1b0f8b3ac537198/6b9fd/table-title.png 518w", "/static/0ce30b06d3e994e3a1b0f8b3ac537198/8ae3e/table-title.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "76.83397683397683%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAIAAABr+ngCAAAACXBIWXMAAAsTAAALEwEAmpwYAAABdklEQVQoz4WS227DIAyG8/6v1oulUm+2du2akBJONXTkABiYmmzrpqXdJ19Y4P/HsilyzilgGl0a/S3cNXJM+SFFciEc2iRMFpfEdeI6C4Nch0pgLa4l6a5FEbsR6bmmp9Vqdayq7W77VJbOu+wxNPIfcepHZNqOg5LSdt0wDMZojyG5gPT8n7gbA5HGGCMVTGEUCMZ6CZGoRXH6okgBw5GPFcNG5RawUa5irhbDrhmOrY/onfO/SV92xezkgn/evjyV5evbm4Tz2ejejXbo7fu7/cNms1mv12VZTuIYh35oCNltd6fTSXABAJ3tFpXW2rquD4fDfr8v5ga89yEERAwhzLm/T5hAxM+2c86ccyFE0zSEkL7vH/yNdoIx9vkyIsYY5zzG+D0SXGK+vU77289aCxNd1wGAMcZam5aWfLlctNYAUPw8qqqKMaa15pxLKQFgUQwASikp5a3txboHbd/2nHOWUhJC2rYFAEopIt4bGKWUTHwA2I9kg5Nj3EAAAAAASUVORK5CYII=')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/b40d91bc3bf792cc57fe7a6c63c56301/8ae3e/table-description.png",
                  "srcSet": ["/static/b40d91bc3bf792cc57fe7a6c63c56301/a2ead/table-description.png 259w", "/static/b40d91bc3bf792cc57fe7a6c63c56301/6b9fd/table-description.png 518w", "/static/b40d91bc3bf792cc57fe7a6c63c56301/8ae3e/table-description.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
      <h3>{`Column Titles`}</h3>
      <ul>
        <li parentName="ul">{`Column titles should stick to one or two words that describe the data in that column.`}</li>
        <li parentName="ul">{`In cases where a column title is too long, the text will wrap to two lines.`}</li>
      </ul>
      <undefined><figure>{`
  `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1035px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "14.671814671814671%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAADCAIAAAAcOLh5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAi0lEQVQI103JbQ+CIBiFYf//n2tsylolrngRVojThweVhCZrqy9nu+5TpT3llNK+p7K56MfjzV/+lVxCZerrnVAQBgOOTLSnWjYXb6xfl1k9VX1mpBk76QF8QHw5QY6i6c1bV4Gxlit0U4wxuMnyfhB9mCC+4wbIqFSt9HZExBnmFcPAte4eTuotLB9fjqlXjNKurgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "",
              "title": "",
              "src": "/static/8402bd8cddc7e7903a26ee4ff3497c31/e3189/column-titles.png",
              "srcSet": ["/static/8402bd8cddc7e7903a26ee4ff3497c31/a2ead/column-titles.png 259w", "/static/8402bd8cddc7e7903a26ee4ff3497c31/6b9fd/column-titles.png 518w", "/static/8402bd8cddc7e7903a26ee4ff3497c31/e3189/column-titles.png 1035w", "/static/8402bd8cddc7e7903a26ee4ff3497c31/387f2/column-titles.png 1518w"],
              "sizes": "(max-width: 1035px) 100vw, 1035px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy"
            }}></img>{`
    `}</span>
        </figure>
        <div {...{
          "className": "two-col"
        }}>{`
  `}<div parentName="div" {...{
            "className": "row"
          }}>{`
    `}<div parentName="div" {...{
              "className": "col col-1"
            }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                  "className": "gatsby-resp-image-wrapper",
                  "style": {
                    "position": "relative",
                    "display": "block",
                    "marginLeft": "auto",
                    "marginRight": "auto",
                    "maxWidth": "756px"
                  }
                }}>{`
      `}<span parentName="span" {...{
                    "className": "gatsby-resp-image-background-image",
                    "style": {
                      "paddingBottom": "31.66023166023166%",
                      "position": "relative",
                      "bottom": "0",
                      "left": "0",
                      "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAxUlEQVQY06XM246CMBAGYN7/pbzYxAtXhK1ItUKjlQ1kOaztWIr0ZCQh0cvNfheT+Sf5J/B/4Zx7jcHzpI3uwMPgQTnRO6E8KM97e5W6AzOM7v2FnT3LRsgmJtk2zePkkh5PyZ6ilKWkys+cFpJVZf2TZ1lRFJRSxpicTWUu6xDvwmi9+NivY/wZoeXqEH4d46TGtD+V5+9LtIkIIQghjDEA3CZT+T6qsjW/oDsYW6FbMS383lz7qlUctDHWWjPPYRb4f3gAth1Vw9EdgeYAAAAASUVORK5CYII=')",
                      "backgroundSize": "cover",
                      "display": "block"
                    }
                  }}></span>{`
  `}<img parentName="span" {...{
                    "className": "gatsby-resp-image-image",
                    "alt": "",
                    "title": "",
                    "src": "/static/c81bdb14b9677c05d7e7dfbc13f0384c/8ae3e/column-header-truncate.png",
                    "srcSet": ["/static/c81bdb14b9677c05d7e7dfbc13f0384c/a2ead/column-header-truncate.png 259w", "/static/c81bdb14b9677c05d7e7dfbc13f0384c/6b9fd/column-header-truncate.png 518w", "/static/c81bdb14b9677c05d7e7dfbc13f0384c/8ae3e/column-header-truncate.png 756w"],
                    "sizes": "(max-width: 756px) 100vw, 756px",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    },
                    "loading": "lazy"
                  }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                    "className": "title title-incorrect"
                  }}>{`Incorrect`}</p>{`
          `}<p parentName="figcaption">{`Don't truncate column titles.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
              "className": "col col-2"
            }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                  "className": "gatsby-resp-image-wrapper",
                  "style": {
                    "position": "relative",
                    "display": "block",
                    "marginLeft": "auto",
                    "marginRight": "auto",
                    "maxWidth": "756px"
                  }
                }}>{`
      `}<span parentName="span" {...{
                    "className": "gatsby-resp-image-background-image",
                    "style": {
                      "paddingBottom": "31.66023166023166%",
                      "position": "relative",
                      "bottom": "0",
                      "left": "0",
                      "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAGCAIAAABM9SnKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAA3ElEQVQY06XN22rDMAwG4L7/W4XACCSsc5dj1zRxu9JdLLZjSbZzwiMpjPV6H7oQP/zSzv/Dznu/TPOiyKPz4DxYr60HN0uYelw287PfZC0PEm4vbzXLmn3KWdGyvE4Okt911qBQZJ7Q5rGs5VEhPxSsKpL966ltjuf6Pc96R3j5wk6SNV3XKaWklEIIrbUxRkqplNo+C31N0jiOq6yY3GCRBloP98cLfAuyhjEWBEGe52EYlmU5jiPnPIqitex60OmZ2jvWN/1xfQycPqHipIGI3B/GGES01jrnfgBW71GtUpAdWQAAAABJRU5ErkJggg==')",
                      "backgroundSize": "cover",
                      "display": "block"
                    }
                  }}></span>{`
  `}<img parentName="span" {...{
                    "className": "gatsby-resp-image-image",
                    "alt": "",
                    "title": "",
                    "src": "/static/754257ebb8b15a4b3816aa35376df5f9/8ae3e/column-header-wrap.png",
                    "srcSet": ["/static/754257ebb8b15a4b3816aa35376df5f9/a2ead/column-header-wrap.png 259w", "/static/754257ebb8b15a4b3816aa35376df5f9/6b9fd/column-header-wrap.png 518w", "/static/754257ebb8b15a4b3816aa35376df5f9/8ae3e/column-header-wrap.png 756w"],
                    "sizes": "(max-width: 756px) 100vw, 756px",
                    "style": {
                      "width": "100%",
                      "height": "100%",
                      "margin": "0",
                      "verticalAlign": "middle",
                      "position": "absolute",
                      "top": "0",
                      "left": "0"
                    },
                    "loading": "lazy"
                  }}></img>{`
    `}</span>{`
        `}<figcaption parentName="figure">{`
          `}<p parentName="figcaption" {...{
                    "className": "title title-correct"
                  }}>{`Correct`}</p>{`
          `}<p parentName="figcaption">{`Let long column titles wrap naturally.`}</p>{`
        `}</figcaption>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
        </div></undefined>
      <h3>{`Table Cells`}</h3>
      <ul>
        <li parentName="ul">{`Table cells can contain just about any kind of content: Text, numbers, images, buttons, inputs, and more.`}</li>
        <li parentName="ul">{`The content within a cell should be left or right aligned. Using center-alignment could make it difficult for a user to scan the column of data.`}</li>
        <li parentName="ul">{`Columns of numbers should typically be right-aligned for better scanning.`}</li>
      </ul>
      <hr></hr>
      <h2>{`Behavior`}</h2>
      <h3>{`Striped Rows`}</h3>
      <p>{`Striped rows (zebra striping) is an optional styling you may apply to your table. This can make data-heavy tables easier for your user to read, as the stripes help guide the eye across the table and then back to the next row.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.907335907335906%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAwUlEQVQY05WPS47FIAwEc/97BqEgbD4NtkJgRsKZ0du+WhWSm7aPOed932OMtdbPlxxjDO+9cw7A8zzjD1XtvavqGENEPl1EVHWtday1Yozee2a2IQAiQkTneV7XpaoxRudcCEFVQwjOOSJ6w7XWnHNKiZnTBkDv/dNzzszcNiklEXnDKSUiYuacM4B7U2ulTd2YAyilxBgBvOFSitW21v5Pba3Zj9bGGzuKiHrvb9h2tjwzxxhtBXtaszkAcwBzzl9TQJHF0N68JgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/25b759bae922cd6ea2c437517a65d1d7/e3189/striped-rows.png",
            "srcSet": ["/static/25b759bae922cd6ea2c437517a65d1d7/a2ead/striped-rows.png 259w", "/static/25b759bae922cd6ea2c437517a65d1d7/6b9fd/striped-rows.png 518w", "/static/25b759bae922cd6ea2c437517a65d1d7/e3189/striped-rows.png 1035w", "/static/25b759bae922cd6ea2c437517a65d1d7/44d59/striped-rows.png 1553w", "/static/25b759bae922cd6ea2c437517a65d1d7/c9d77/striped-rows.png 1964w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <h3>{`Hover`}</h3>
      <p>{`The table’s row hover state can help your user visually scan the columns of data in a row even if the row is not interactive. This feature is optional and is easily enabled for any table, and may be used in combination with striped rows.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "35.907335907335906%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAHCAIAAACHqfpvAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAyElEQVQY05WQQY7DIAwA8/+HAiUYEwhgDCarwqqq9rZzGiSPJXyISO9dRJ7/czDz6/U6z7O11r8golIKEfXea63bmfnjc85DRADAGBNCIKJaa86ZiBBRKbWXAoDWGgCIyDmnlELE39h7D4tzYa1FxBijW4QQrusCAOfctXDOxRhF5BhjWGvNwlrrvUfEPaEXO9NaG2M+DgDv+HmeUsp93znnfbkxhogw871g5tbat6eUmPl9sDnn/mcpJS9SSrVWZt7PHfzxHf8Aix6R+9CJBMQAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/a7ef96d1a11c4bfadfb98dd58c99e4d1/e3189/row-hover.png",
            "srcSet": ["/static/a7ef96d1a11c4bfadfb98dd58c99e4d1/a2ead/row-hover.png 259w", "/static/a7ef96d1a11c4bfadfb98dd58c99e4d1/6b9fd/row-hover.png 518w", "/static/a7ef96d1a11c4bfadfb98dd58c99e4d1/e3189/row-hover.png 1035w", "/static/a7ef96d1a11c4bfadfb98dd58c99e4d1/44d59/row-hover.png 1553w", "/static/a7ef96d1a11c4bfadfb98dd58c99e4d1/c9d77/row-hover.png 1964w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <h3>{`Sorting`}</h3>
      <p>{`Columns can be sorted in ascending or descending order. Sorting controls are located in the column headers and indicated with an arrow icon to the right of the label.`}</p>
      <p>{`A sorted table has three states: unsorted (sort-double-arrow), sorted-up (arrow-upward) or sorted-down (arrow-downward). The icon indicates the current sorted state. All sortable columns display an arrow icon, but only one can be actively sorted at a time.`}</p>
      <figure>{`
  `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1035px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "40.15444015444015%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAICAIAAAB2/0i6AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAv0lEQVQY06WQy46DMAxF+f9vRCywSCIbSHATIAnEM4Uu6GNT9SxtH/nqVvIDlYjM80xEzrlxHK21+76/HJWDz3IIQSk1DAMiKqW2bfvicynlNL33McblDWMMAPR9z8zX+V1OKQFA0zRExMy3Z7z3bdvWda21ds5dV9UZYFkWZp6mKedc3vAH1toQgojsB6WUR+yc8xn4bOtFTinFGNd1vdbxkEXEWgsARKS1RsSc87VkRDTGEJExBhG7rkPEf/kPhnTQ0WoLd/UAAAAASUVORK5CYII=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "",
            "title": "",
            "src": "/static/83b27f31e9af3a7ee4ed2e798287cccc/e3189/table-sorting.png",
            "srcSet": ["/static/83b27f31e9af3a7ee4ed2e798287cccc/a2ead/table-sorting.png 259w", "/static/83b27f31e9af3a7ee4ed2e798287cccc/6b9fd/table-sorting.png 518w", "/static/83b27f31e9af3a7ee4ed2e798287cccc/e3189/table-sorting.png 1035w", "/static/83b27f31e9af3a7ee4ed2e798287cccc/2e367/table-sorting.png 1066w"],
            "sizes": "(max-width: 1035px) 100vw, 1035px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </figure>
      <h3>{`Inline Actions`}</h3>
      <p>{`Inline actions are functions that may be performed on a specific table row. In order to save space, inline actions can be condensed under a single overflow menu.`}</p>
      <div {...{
        "className": "two-col"
      }}>{`
  `}<div parentName="div" {...{
          "className": "row"
        }}>{`
    `}<div parentName="div" {...{
            "className": "col col-1"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "67.56756756756756%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByUlEQVQoz42RbavUMBCF9///F/0siojIRcUX8Oqq21K3tE27TbttN2km751Lmu26+MmHEE4STpiZs6vrmhDS931RFGVZdl1HCKmqinM+r4AQ3/enYbiAs/37h/Hx22yMVgoRd8uyIKL3/h9h7nDOaW2M0dZ7G7R2zgXzMAyEkHEcm5UoCCHee0SMH6XZpW0FIrLXr+Dr53C/vu4AgHMOAIyxKOZ55pxba91G1wmjjUeUVaUodWuBwSyEiL2JlXlDbACENU0cJPDzeZ6mWQitdTAXRXE4HKqqSpIkTdOyLNM0TZKEMRb/0ho+fSH5sbOIp+fP+rdvYMHrwABAa62UkitqQ0oJK0KEZYwKVSgFKghjTDBLKRljsfMQzNo8Y2wbGCLiMKpxkIgIh9+6LHB7CNNummaaptu0KaVN09ybD+nELqFO/vAOfjziGmkwO+eWZbHWxoSdc1HIO6w1WisAUM4pawHgWnZd11mWEUKOK1VV5XmeZRljLGamlNj/avNjp3GhL1+cP36YrbsOrOs6SukwDKfTKQpKadu2t7QAxDHvp5FJa8af+8ufLAQVo4pFxj2KW/031mvnbFDO+9hjMON/EMd2VX8P+AQWFSAGNeSnVwAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/eb44f52a201606c4b16de74450a7361e/8ae3e/inline-actions.png",
                  "srcSet": ["/static/eb44f52a201606c4b16de74450a7361e/a2ead/inline-actions.png 259w", "/static/eb44f52a201606c4b16de74450a7361e/6b9fd/inline-actions.png 518w", "/static/eb44f52a201606c4b16de74450a7361e/8ae3e/inline-actions.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
    `}<div parentName="div" {...{
            "className": "col col-2"
          }}>{`
      `}<figure parentName="div">{`
        `}<span parentName="figure" {...{
                "className": "gatsby-resp-image-wrapper",
                "style": {
                  "position": "relative",
                  "display": "block",
                  "marginLeft": "auto",
                  "marginRight": "auto",
                  "maxWidth": "756px"
                }
              }}>{`
      `}<span parentName="span" {...{
                  "className": "gatsby-resp-image-background-image",
                  "style": {
                    "paddingBottom": "67.56756756756756%",
                    "position": "relative",
                    "bottom": "0",
                    "left": "0",
                    "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAIAAACgpqunAAAACXBIWXMAAAsTAAALEwEAmpwYAAABtElEQVQoz6WR7YrjIBSGe/93srAXU0ihQ9tMN9HYJhpj/NZj4tLYdmdg/u3zQ17ER46vu7qu9/v99Xo9HA5VVdV1fTweq6oSQhhj9AultLPmRjgdhDE6hJBz3qWUcs4ppWVZSljXNefsvXffMdYhLm9COWdjjA9Zaz0Mg1KKb0gpOeeMsXJXYbst9zpi5hrqJgePzZx3QgjOuTGGUjqOo9aaMUYpBYD0AiDlZbnPls32Nllh41MOIcQYvfcxRgBwzgHAuq7lIWUtpGWFZQkAWuvn2Aih0+mEMT6fz5fLpW3bEMLnZ22t6fseIcQYI4RgjEs7y7JIKZ+yEGKapnmeOefThvcetnOlua+hyPM8/2s7hAAAZWzvXMpZ/P4V6UCn6c/12nUd5/y2EUJY17WYD3kcR4zxNE1d1xFCGGMRwJ4+kjURwBhjrfXeW2udc6UFAHjKMcb3VulWa21ilEpJKdXGO2xxttaW9+8opRjjvu/JxjAMhJAOISWl/o4xmnMphNJae+8fMiGkbdu+75umadv2fr8jhJqmkT/JwyDGcd7kV2Ff//Md4k+kFAFiCOE5dv4P/gLjRiJq+Y9mWQAAAABJRU5ErkJggg==')",
                    "backgroundSize": "cover",
                    "display": "block"
                  }
                }}></span>{`
  `}<img parentName="span" {...{
                  "className": "gatsby-resp-image-image",
                  "alt": "",
                  "title": "",
                  "src": "/static/fd4e5fab519d813c82a69dd786f23455/8ae3e/inline-actions-overflow.png",
                  "srcSet": ["/static/fd4e5fab519d813c82a69dd786f23455/a2ead/inline-actions-overflow.png 259w", "/static/fd4e5fab519d813c82a69dd786f23455/6b9fd/inline-actions-overflow.png 518w", "/static/fd4e5fab519d813c82a69dd786f23455/8ae3e/inline-actions-overflow.png 756w"],
                  "sizes": "(max-width: 756px) 100vw, 756px",
                  "style": {
                    "width": "100%",
                    "height": "100%",
                    "margin": "0",
                    "verticalAlign": "middle",
                    "position": "absolute",
                    "top": "0",
                    "left": "0"
                  },
                  "loading": "lazy"
                }}></img>{`
    `}</span>{`
      `}</figure>{`
    `}</div>{`
  `}</div>
      </div>
    </PageContent>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      